import React from 'react';
import { Table, EllipsisDropdown, ControlledPopup, USER_PERMISSIONS } from 'dyl-components';
import { Dropdown, Icon } from 'semantic-ui-react';

import HorizontalFlexList from './HorizontalFlexList';
import RestrictedView from 'shared/RestrictedView';

const TerritoryRow = ({ name, territoryLimit, teams, onEdit, onDelete }) => {
    const hasTeams = teams.length > 0;
    
    return (
        <Table.Row>
            <Table.Cell>
                <b>{name}</b>
            </Table.Cell>
            <Table.Cell>
                <HorizontalFlexList
                    limit={territoryLimit}
                    entries={teams} />
            </Table.Cell>
            <Table.Cell>
                <EllipsisDropdown>
                    <RestrictedView userPermission={USER_PERMISSIONS.TERRITORIES_EDIT} type="disabled">
                        <Dropdown.Item
                            onClick={onEdit}
                            text={<React.Fragment>
                                <Icon name='pencil' />
                                Edit
                            </React.Fragment>}
                            style={{ cursor: 'pointer' }} />
                    </RestrictedView>
                    <RestrictedView userPermission={USER_PERMISSIONS.TERRITORIES_DELETE} type="controlledPopupDisabled">
                        <ControlledPopup
                            trigger={
                                <Dropdown.Item
                                    disabled={hasTeams}
                                    text={<React.Fragment>
                                        <Icon name='trash' />
                                        Delete
                                    </React.Fragment>}
                                    style={{ cursor: 'pointer' }} />
                            }
                            onConfirm={onDelete}
                            inverted
                        />
                    </RestrictedView>
                </EllipsisDropdown>
            </Table.Cell>
        </Table.Row>
    )
}

export default TerritoryRow;
